import { render, staticRenderFns } from "./ConfigurarPermissoes.vue?vue&type=template&id=266707fd&"
import script from "./ConfigurarPermissoes.vue?vue&type=script&lang=js&"
export * from "./ConfigurarPermissoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports